import { css } from 'styled-system/css';
import { Cell } from './Cell';
import { RowGutter } from './RowGutter';

export function EmptyRow({
  n,
  wide,
  soft,
  cols,
}: {
  n: number;
  wide?: boolean;
  soft?: boolean;
  cols: number;
}) {
  return (
    <div
      data-wide={wide || undefined}
      className={css({
        display: 'grid',
        gridTemplateColumns:
          '36px minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr)',
        borderBottom: '1px solid token(colors.border.hairline)',
        minHeight: '28px',
        '&[data-wide]': {
          gridTemplateColumns: '47px repeat(7, 64px)',
        },
      })}
    >
      <RowGutter n={n} soft={soft} />
      {Array.from({ length: cols }, (_, c) => (
        <Cell key={c} />
      ))}
    </div>
  );
}
